import BaseDrawer from "@stardust/base-drawer";
import { initAccordion } from "@stardust/accordion";

class MobileMenuDrawer extends BaseDrawer {
  constructor(element) {
    super(element, {
      openClass: 'opacity-0 -translate-x-full',
      closeClass: 'opacity-0 -translate-x-full',
    });
  }

  /** Move the single search node into the header slot (search visible in header, no CLS) */
  moveSearchToHeader() {
    if (this._searchWrapper && this._headerSlot) {
      this._headerSlot.appendChild(this._searchWrapper);
    }
  }

  /** Move the search node into the drawer when drawer is open */
  moveSearchToDrawer() {
    if (this._searchWrapper && this._drawerSearchSlot) {
      this._drawerSearchSlot.appendChild(this._searchWrapper);
    }
  }

  onOpen() {
    this.moveSearchToDrawer();
  }

  onClose() {
    this.moveSearchToHeader();
  }

  load() {
    // Listen for open event
    document.addEventListener("mobile-menu:open", () => this.toggle());

    // Listen for close event
    document.addEventListener("mobile-menu:close", this._boundClose);

    // Single search node: lives in header on first paint (no CLS). Move to drawer when menu opens, back to header when closed.
    this._headerSlot = document.querySelector("[data-mobile-header-search-slot]");
    this._searchWrapper = this._headerSlot?.querySelector(".mobile-menu-drawer__search");
    this._drawerSearchSlot = this.element.querySelector("[data-mobile-menu-drawer-search-slot]");

    // When JS is available: show search trigger (opens mobile search drawer), hide fallback form
    if (this._searchWrapper) {
      const searchTrigger = this._searchWrapper.querySelector(".js-enabled-search-trigger");
      const searchFallback = this._searchWrapper.querySelector(".js-fallback-search");
      if (searchTrigger && searchFallback) {
        searchTrigger.style.display = "block";
        searchFallback.style.display = "none";
      }
    }

    // Initialize accordion functionality for mobile navigation
    const navList = this.element.querySelector('[data-accordion="mobile-navigation"]');
    if (navList) {
      initAccordion(navList, {
        exclusive: true,
      });
    }
  }
}

// Initialize mobile menu drawer
const init = () => {
  const mobileMenuDrawer = document.querySelector('[data-mobile-menu-drawer]');
  if (mobileMenuDrawer) new MobileMenuDrawer(mobileMenuDrawer).load();
};
init();
